export const messages = {
    en: {
        //tabs
        chat: "Chat",
        new_chat: "New Chat",
        feedback: "Feedback",
        resource: "Resources",
        setting: "Account",
        recharge: "Recharge",
        rechargeDetail: "Recharge detail",
        transfer: 'Transfer deer antler',
        profile: "Profile",
        avatar: 'Avatar',
        alias: 'Alias',
        profession: 'Profession',
        age: 'Age',
        pleaseEnter: 'Please enter',

        //registration, setting
        GiraffeTitle: 'GiraffeEars',
        loginTitle: 'Log in with email and password',
        registerTitle: 'Sign up with email and password',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        login: 'Log in',
        signup: 'Sign up',
        noAccount: "Don't have an account?",
        logout: 'Logout',
        save: 'Save',
        emailConfirmMsg: 'Welcome! Check your email and click the confirmation link',
        pwdNoMatch: 'Passwords do not match',

        loadingText: 'Loading...',

        // added by Jun Wang 2024-03-10
        chatpage_title: 'Chat',
        chat_reminder: ' * GiraffeEars can’t give you medical advice.',
        chat_open: '* GiraffeEars isn’t designed for crisis.',
        chat_confidential1: '* GiraffeEars isn’t designed for users under 18. This service is not available to residents of Illinois.',
        chat_see_you_again: 'welcome back!',
        chat_ai_greeting: 'What would you like to talk about today? Describe it in one or two sentences.',
        chat_if_suicide_thought: 'If you are thinking about harming yourself or feel at risk of acting on these thoughts, please call your local emergency number or a crisis hotline right away - US & Canada: 988; UK: 116 123; Australia: 13 11 14; ',
        chat_method_scope: 'I use humanistic and cognitive-behavioral counseling approaches to help you better understand yourself and ease everyday psychological challenges.',
        chat_confidential: 'Everything we talk about will be kept completely confidential.',
        chat_time_scale: 'A typical session lasts 40–60 minutes and covers 4 to 8 blocks, depending on your needs.',
        chat_quiet_space: 'Find a quiet personal space where you can slow down and connect with your thoughts and feelings.',
        chat_click_start: 'I have an hour — tap to start a session',
        chat_voice0: 'Want to use voice input? Check your keyboard:',
        chat_voice1a: '🍎 iPhone (default keyboard): Tap the microphone icon',
        chat_voice1b: ' at the bottom right',
        chat_voice2a: '🤖 Android or Gboard: Tap the microphone icon',
        chat_voice2b: ' near the space bar or on the top bar',
        chat_voice3a: '🧠 SwiftKey: Tap the microphone icon',
        chat_voice3b: ' on the toolbar above the keyboard, or open “…” (more) if it’s hidden',

        chat_click_here: 'or click here for other area.',
        login_required_title: 'Giraffe needs you to sign in',
        login_required_msg: 'To continue with your personal AI support, please sign in first.',
        go_to_login: 'Go to Login',

        recharge_use: 'Service used, deducted',
        recharge_charge: 'Recharge, added',
        recharge_transferout: 'Transferred out, deducted',
        recharge_transferin: 'Received transfer, added',
        recharge_rewardUsing: 'Started using, rewarded',
        recharge_rewardUsingFeedback: 'In-use feedback, rewarded',
        recharge_rewardRecmRegister: 'Referred registration, rewarded',
        recharge_rewardRecmUse: 'Referred usage, rewarded',
        recharge_rewardRegister: 'Registration success, rewarded',
        recharge_rewardFeedback: 'Feedback submitted, rewarded',
        insufficient_antlers_prefix: "You don't have enough Antlers. Please ",
        recharge_amount: "recharge ${amount}",
        insufficient_antlers_suffix: " or more to continue.",
        antlersAmount: "Antlers Amount",
        viewDetail: "View detail",
        confirmRecharge: "Confirm",
        cancel: "Cancel",
        enterAmount: "Enter amount",
        // TO_ADD_BY_BOT_EN

        feedback_title: 'Feedback',
        feedback_welcome: 'Please feel free to give us your',
        feedback_line: 'feedback, suggestions, and comments.',

        resource_title: 'Resources',
        resource_teacher_ellen: 'Ellen leads: Body meditation practice',
        resource_feeling_awareness_example: 'More about of feeling: examples',
        resource_cognitive_behavior_example: 'Examples of cognitive behavior',
        resource_suicide_help_hotline: 'Suicide crisis hotline numbers',
        resource_feeling_vocabulary: 'Feelings vocabulary',
        resource_need_vocabulary: 'Needs vocabulary',

        cbt_example: {
            intro: 'Behind our feelings, there are often beliefs that influence how we view things.',
            example_title: 'Example',
            scenario: 'Scenario: Two people, A and B, are walking down the street when they encounter C, who knows both of them. C doesn\'t look at them and doesn\'t say hello.',
            a_thought: 'A thinks: "He might be deep in thought and didn\'t notice us, or there\'s something I don\'t know about."',
            b_thought: 'B thinks: "He\'s looking down on us and ignoring us on purpose."',
            result: 'As a result, A and B have different emotional reactions.',
            a_belief: 'Behind A\'s calmness might be a belief in "treating others with kindness".',
            b_belief: 'Behind B\'s frustration and anger might be an over-interpreting belief like "if someone doesn\'t say hello, they\'re being rude," or a negative-thinking belief like "others don\'t respect me."',
        },
        feeling_awareness_example: {
            intro: 'Could you tell me more about your feelings?',
            example_title: 'Example',
            worry: 'About Worry:',
            worry_desc: 'I\'m worried that others might look down on me.',
            sadness: 'About Sadness:',
            sadness_desc: 'When I feel sad, my heart truly hurts.',
            anger: 'About Anger:',
            anger_desc: 'I\'m angry with him, and also with myself.',
            grievance: 'About Grievance:',
            grievance_desc: 'I feel so wronged that I\'m about to cry.',
            loneliness: 'About Loneliness:',
            loneliness_desc: 'There\'s not even anyone to talk to.',
            fatigue: 'About Fatigue:',
            fatigue_desc: 'I\'m tired in my body and my heart; I have no energy.',
        },

        settingPage: {
            antlers: 'Antlers',
            antlersNum: 'Antlers num',
            rewardRules: 'Reward rules',
            give: 'Give',
            reCharge: 'Recharge',
            recmTransfer: 'Transfer',
            myCode: 'My code',
            myRecmCode: 'My referral code',
            copy: 'Copy',
            view: 'View',
            more: 'More',
            recmCodeTips: 'Inform others that they can accept deer antlers as gifts',
            share: 'Share',
            notFilled: 'Not filled',
            rewardTitle: 'Reward Rules',
            rewardIntro: 'Antlers are the internal consumption tokens of the GiraffeEars platform, 10 Antlers = $1. You can use Antlers to purchase related services within GiraffeEars.',
            rewardSources: 'Sources of Antlers',
            rewardSource1: '1. Purchase: Click the "Recharge" button to open the recharge interface.',
            rewardSource2: '2. System Reward:',
            rewardSource2A: 'A. Successful initial registration: 2028 Antlers',
            rewardSource2B: 'B. Referral: Refer a user to start using: 48 Antlers',
            rewardSource2C: 'C. Feedback: Submit feedback or comments for a chance to earn rewards.',
            rewardUsageWithdraw: 'Usage and Withdrawal',
            rewardUsageWithdrawDetail: 'When using the service, the system prioritizes using recharged Antlers (if any). When withdrawing, it is limited to the remaining portion of recharged Antlers. For any questions, please contact customer support.',
            copied: 'Copied successfully',
            shareTips: 'Click the menu " ... " in the upper right corner to share'
        },
        profileSettings: {
            ageList: ['2010s', '2000s', '1990s', '1980s', '1970s', '1960s', '1950s', 'Before 1950'],
            professionList: ['Working', 'Student', 'Retired', 'Freelance'],
            genderList: ['Male', 'Female']
        }
    },
    zh: {
        //tabs
        chat: "谈话",
        new_chat: "新建",
        feedback: "反馈",
        resource: "资源",
        setting: "我的",
        recharge: "充值",
        rechargeDetail: "鹿角变动明细",
        transfer: '转赠鹿角',
        profile: "个人信息",
        avatar: '头像',
        alias: '昵称',
        profession: '工作',
        age: '年龄',
        pleaseEnter: '请输入',
        save: '保存',

        //registration, setting
        GiraffeTitle: '长颈鹿耳朵',
        loginTitle: '请用电邮登录',
        registerTitle: '请用电邮注册新账户',
        email: '电邮',
        password: '密码',
        confirmPassword: '再次输入密码',
        login: '登录',
        signup: '注册',
        noAccount: "还没有账户?",
        logout: '登出',
        emailConfirmMsg: '欢迎! 请查收电邮，并点击邮件中的确认链接',
        pwdNoMatch: '输入的两个密码不匹配',

        loadingText: '加载中...',

        // added by Jun Wang 2024-03-10
        chatpage_title: '谈话',
        chat_reminder: '温馨提示：',
        chat_open: '* 好的体验来自真实的内心需求，前两次体验的鹿角由长颈鹿提供，请珍惜哦。',
        chat_confidential1: '* 与长颈鹿耳朵的对话为您全程保密。自我开放度越高，效果越好。',
        chat_see_you_again: '你好，我们又见面了。',
        chat_ai_greeting: '今天想跟我聊点什么呢？用一两句话描述。',
        chat_if_suicide_thought: '如果你最近一个月内有过轻生的念头，请',
        chat_click_here: '点击这里',
        chat_method_scope: '我用人本主义和认知行为等心理咨询方法，促进你更多地理解和懂得自己，疏解各种日常心理烦恼，包括婚恋、家庭、夫妻、育儿、职场、学业、个人的问题，各种心情困扰。',
        chat_confidential: '谈话内容为您保密。',
        chat_time_scale: '一次访谈时间约 40-60 分钟，包括4到8个模块（根据不同情况需要）。',
        chat_quiet_space: '在一个安静的个人空间，慢下来思考和体验，才会有帮助。',
        chat_click_start: '我有一个小时，做一次访谈吧',
        chat_voice0: '想用语音输入？看看你的键盘',
        chat_voice1a: '📱多数手机：长按空格键（键上有麦克风图标',
        chat_voice1b: '）',
        chat_voice2a: '🍎苹果手机：点击键盘右下角的麦克风图标',
        chat_voice2b: '',
        chat_voice3a: '📱部分机型：点击键盘右下/左下/右上角的麦克风图标',
        chat_voice3b: '',

        chat_click_here: '点击这里',
        login_required_title: '小鹿需要你先登录',
        login_required_msg: '为了继续为您提供个人AI支持，请先登录。',
        go_to_login: '去登录',

        recharge_use: '使用服务，扣除',
        recharge_charge: '充值，增加',
        recharge_transferout: '转赠他人，扣除',
        recharge_transferin: '获得他人转赠，增加',
        recharge_rewardUsing: '开始使用，奖励',
        recharge_rewardUsingFeedback: '使用中反馈，奖励',
        recharge_rewardRecmRegister: '推荐他人注册，奖励',
        recharge_rewardRecmUse: '推荐他人使用，奖励',
        recharge_rewardRegister: '注册成功，奖励',
        recharge_rewardFeedback: '提交反馈，奖励',
        insufficient_antlers_prefix: "目前你的鹿角不够，请",
        recharge_amount: "充值 {amount} 元",
        insufficient_antlers_suffix: "以上，才能继续",
        antlersAmount: "鹿角数量",
        viewDetail: "查看明细",
        confirmRecharge: "确定充值",
        cancel: "取消",
        enterAmount: "输入充值金额",
        // TO_ADD_BY_BOT_ZH

        feedback_title: '反馈',
        feedback_welcome: '欢迎随时反馈',
        feedback_line: '使用过程中的问题、意见、建议',

        resource_title: '资源',
        resource_teacher_ellen: '玉鹿老师带领：身体冥想练习',
        resource_feeling_awareness_example: '感受觉察示例：多说说感受',
        resource_cognitive_behavior_example: '认知行为示例',
        resource_suicide_help_hotline: '自杀干预、心理援助热线',
        resource_feeling_vocabulary: '感受词汇表',
        resource_need_vocabulary: '需要词汇表',

        cbt_example: {
            intro: '感受背后，往往有一些信念，影响着我们对事情的看法。',
            example_title: '示例',
            scenario: '情境：甲乙两个人走在路上，迎面走过一个认识他俩的丙。丙没看他们，也没跟他们打招呼。',
            a_thought: '甲认为：“他可能在想事情，没注意到我们，或者有什么我不了解的情况。”',
            b_thought: '乙认为：“他看不起我们，故意不理我们。”',
            result: '于是甲乙的情绪反应不一样。',
            a_belief: '甲的平静背后可能有“宽以待人”的信念。',
            b_belief: '乙的郁闷、生气背后，可能有“不打招呼就是对我不礼貌”这种过分解读的信念，或者“别人不尊重我”这种带有负面思维的信念。',
        },
        feeling_awareness_example: {
            intro: '关于感受，能再跟我多说说吗？',
            example_title: '示例',
            worry: '关于担心：',
            worry_desc: '我担心别人看不起我。',
            sadness: '关于难过：',
            sadness_desc: '我难过起来，心真的会痛',
            anger: '关于生气：',
            anger_desc: '我气他，也气自己。',
            grievance: '关于委屈：',
            grievance_desc: '我委屈得眼泪都要下来了',
            loneliness: '关于孤单：',
            loneliness_desc: '连个说话的人都没有。',
            fatigue: '关于累：',
            fatigue_desc: '身上累，心也累，没精神。',
        },

        settingPage: {
            antlers: '鹿角',
            antlersNum: '鹿角数量',
            rewardRules: '奖励规则',
            give: '赠送',
            reCharge: '充值',
            recmTransfer: '推荐转赠',
            myCode: '我的编号',
            myRecmCode: '我的推荐码',
            copy: '复制',
            view: '查看',
            more: '查看更多',
            recmCodeTips: '告知他人，可接受对方转赠的鹿角',
            share: '分享',
            notFilled: '未填写',
            rewardTitle: '奖励规则',
            rewardIntro: '鹿角是《长颈鹿耳朵》平台内部使用的消费代币，2鹿角=1人民币。在《长颈鹿耳朵》内部可以使用鹿角来购买相关服务。',
            rewardSources: '鹿角的来源',
            rewardSource1: '1. 充值购买：点击“充值”按钮，打开充值界面。',
            rewardSource2: '2. 系统赠送：',
            rewardSource2A: 'A. 初次注册成功，赠送2028鹿角',
            rewardSource2B: 'B. 成功推荐用户使用，累计奖励48鹿角',
            rewardSource2C: 'C. 反馈或评价，有机会获得鹿角奖励',
            rewardUsageWithdraw: '鹿角的使用及提现',
            rewardUsageWithdrawDetail: '使用本服务时，系统优先使用充值的鹿角（如果有）。鹿角提现时，仅限于提现充值鹿角的剩余部分。如有疑问，请联系客服。',
            copied: '复制成功',
            shareTips: '点击右上角菜单“ ... ”进行分享'
        },
        profileSettings: {
            ageList: ['10后', '00后', '90后', '80后', '70后', '60后', '50后', '50前'],
            professionList: ['工作', '学生', '退休', '自由'],
            genderList: ['男', '女']
        }
    },

};

